import * as Questions from './questions'
import {
    getSurveyFromFireStore,
    addSurveyToFireStore,
    loginAnonymously,
    setAuthChangeListener
} from './Config/config.js'

export var currentUser = undefined

export const login = () => {
    return loginAnonymously()
}

export const loginAndUpdateSession = () => {
    return login()
        .then(logInData => setSessionAnynomousUser(logInData.user))
}

export const loginAndUpdateSessionRegisteredIfRequired = () => {
    // Checks if the current session was pre-registry
    // and if the user has not yet logged in anonymously
    // In that case, it will login the user and then update
    // the session object
    if (currentSession.preregistered && !currentSession.userId) {
        return loginAndUpdateSession()
    } else {
        return Promise.resolve()
    }
}

setAuthChangeListener((user) => {
    if (user) {
        currentUser = user
        currentSession.userId = user.uid
        console.info(`user logged in as ${user.uid}`)
    } else {
        currentUser = undefined
        currentSession.userId = undefined
        console.warn(`user NOT logged in`)
    }
})

export const setSessionAnynomousUser = (user) => {
    currentSession.userId = user.uid
    console.log(currentSession)
}

export const currentSession = {
    sectorId: undefined,
    companyId: undefined,
    contactEmail: undefined,
    additionalContactAuthorized: true, // default value
    responses: undefined,
    isFinished: false,
    userId: undefined
}

export const hasUser = () => !!currentUser && !!currentUser.uid

export const isInitiated = () => !!currentSession.sectorId && !!currentSession.contactEmail

export const isFinished = () => currentSession.isFinished

export const saveCurrentSession = (userEmail = currentSession.contactEmail, additionalPayload = {}) => {
    const payload = { ...currentSession,
        ...additionalPayload
    }
    return addSurveyToFireStore(userEmail, payload)
}

export const getSessionForUserEmail = (userEmail) => {
    return getSurveyFromFireStore(userEmail).then(documentSnapshot => {
        const storeSession = documentSnapshot.data()
        mergeWith(storeSession)
        return currentSession
    })
}

export const updateSectorIfRequired = (sectorId) => {
    if (!currentSession.sectorId || !currentSession.responses) {
        set('sectorId', sectorId)
    }
}

export const set = (key, value) => {
    currentSession[key] = value
    if (key === 'sectorId') {
        currentSession.responses = Questions.Templates[currentSession.sectorId]
    }
}

const isObject = obj => obj && obj.constructor && obj.constructor === Object;

export const mergeWith = (obj) => {
    if (isObject(obj)) {
        // Merges all the keys into the current session object
        Object.keys(obj).forEach(key => currentSession[key] = obj[key])
        // Ensures that the template responses are loaded the first time a
        // preregistered survey is loaded
        if (obj.preregistered && obj.sectorId && !currentSession.responses) {
            set('sectorId', obj.sectorId)
        }
    }
}

export const isReadyToStart = () => {
    let conditions = [
        isValidSector(currentSession.sectorId),
        isValidCompanyId(currentSession.companyId),
        isValidEmail(currentSession.contactEmail)
    ]
    return conditions.every(condition => condition === true)
}

export const isValidSector = (sectorId) => sectorId !== undefined && sectorId.length > 0
export const isValidCompanyId = (companyId) => companyId !== undefined && companyId.length > 0

export const isValidEmail = (email) => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const registerUrl = () => (
    `/register`
)

export const startSubSectionUrl = (userEmail = currentSession.contactEmail) => (
    `/user/${userEmail}/section/0/subsection/0`
)

export const thankYouUrl = (userEmail = currentSession.contactEmail) => (
    `/user/${userEmail}/thanks`
)

export const reportUrl = (userEmail = currentSession.contactEmail) => (
    `/user/${userEmail}/report`
)

window.___generateRandomResponse = () => {
    currentSession.responses = currentSession.responses || Questions.Agro
    Questions.generateRandomResponseForAllQuestionsInTree(currentSession.responses)
    console.log(currentSession.responses)
}


// WEBPACK FOOTER //
// ./src/session.js